import React from "react";
import { serviceTypeEnum } from "../../../../constants/enums/service-type-enum";
import { getOptionNameFromServiceName } from "../../../../constants/constants";

// Component to display service names with tooltip
const ServiceNameDisplayComponent = ({ services }: any) => {
    // Return a fallback message if no services are provided
    if (!services || services?.length === 0) return <span>No services</span>;

    // Extract service names from the services array
    const serviceNames = services?.map((service: any) => {
        let serviceName = service.ServiceType === serviceTypeEnum.Option ? getOptionNameFromServiceName(service?.ServiceName) : service?.ServiceName ; 
        return serviceName
    });
    
    // Determine the display text based on the number of services
    const displayText =
        serviceNames?.length > 1 ? `${serviceNames[0]}...` : serviceNames[0];
    // Combine all service names into a single tooltip text
    const tooltipText = serviceNames?.join(", ");

    // Render the service name with a tooltip
    return <span title={tooltipText}>{displayText}</span>;
};

export default ServiceNameDisplayComponent;
